import { useRef, useEffect } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';

import { KeyboardShortcuts } from '@/shared/constants/keyboardShortcuts';
import { CameraPtzAdjustment } from '../types/CameraPtzAdjustment';


const useCameraPtzKeyboardBindings = (onPtzChange: (adjustment: CameraPtzAdjustment) => void) => {
  // Use ref to store the latest callback version without triggering re-initialization
  const onPtzChangeRef = useRef(onPtzChange);

  // Update ref when callback changes
  useEffect(() => {
    onPtzChangeRef.current = onPtzChange;
  }, [onPtzChange]);

  // Log only once on mount
  useEffect(() => {
  }, []);

  const hotkeyOptions = {
    enableOnFormTags: false,
    enableOnContentEditable: false,
    preventDefault: true
  };

  // Register all hotkeys with stable callbacks using refs
  useHotkeys(KeyboardShortcuts.TiltUp.hotkey, (e) => {
    e.preventDefault();
    onPtzChangeRef.current({ tiltDiff: 1 });
  }, { ...hotkeyOptions, keydown: true });

  useHotkeys(KeyboardShortcuts.TiltUp.hotkey, (e) => {
    e.preventDefault();
    onPtzChangeRef.current({ tiltDiff: 0 });
  }, { ...hotkeyOptions, keyup: true });

  useHotkeys(KeyboardShortcuts.TiltDown.hotkey, (e) => {
    e.preventDefault();
    onPtzChangeRef.current({ tiltDiff: -1 });
  }, { ...hotkeyOptions, keydown: true });

  useHotkeys(KeyboardShortcuts.TiltDown.hotkey, (e) => {
    e.preventDefault();
    onPtzChangeRef.current({ tiltDiff: 0 });
  }, { ...hotkeyOptions, keyup: true });

  useHotkeys(KeyboardShortcuts.PanLeft.hotkey, (e) => {
    e.preventDefault();
    onPtzChangeRef.current({ panDiff: -1 });
  }, { ...hotkeyOptions, keydown: true });

  useHotkeys(KeyboardShortcuts.PanLeft.hotkey, (e) => {
    e.preventDefault();
    onPtzChangeRef.current({ panDiff: 0 });
  }, { ...hotkeyOptions, keyup: true });

  useHotkeys(KeyboardShortcuts.PanRight.hotkey, (e) => {
    e.preventDefault();
    onPtzChangeRef.current({ panDiff: 1 });
  }, { ...hotkeyOptions, keydown: true });

  useHotkeys(KeyboardShortcuts.PanRight.hotkey, (e) => {
    e.preventDefault();
    onPtzChangeRef.current({ panDiff: 0 });
  }, { ...hotkeyOptions, keyup: true });

  useHotkeys(KeyboardShortcuts.ZoomIn.hotkey, (e) => {
    e.preventDefault();
    onPtzChangeRef.current({ zoomDiff: -1 });
  }, { ...hotkeyOptions, keydown: true });

  useHotkeys(KeyboardShortcuts.ZoomIn.hotkey, (e) => {
    e.preventDefault();
    onPtzChangeRef.current({ zoomDiff: 0 });
  }, { ...hotkeyOptions, keyup: true });

  useHotkeys(KeyboardShortcuts.ZoomOut.hotkey, (e) => {
    e.preventDefault();
    onPtzChangeRef.current({ zoomDiff: 1 });
  }, { ...hotkeyOptions, keydown: true });

  useHotkeys(KeyboardShortcuts.ZoomOut.hotkey, (e) => {
    e.preventDefault();
    onPtzChangeRef.current({ zoomDiff: 0 });
  }, { ...hotkeyOptions, keyup: true });
};

export default useCameraPtzKeyboardBindings;